import axios from "axios";

const apiEndpoint = "https://dead-heads-api.herokuapp.com/";

export function getOrders(signature, address) {
  return axios.get(apiEndpoint + "api/merch", {
    headers: {
      signature,
      address,
    },
  });
}

export function getRequests(address) {
  return axios.get(apiEndpoint + `api/merch/requests/${address}`);
}

export function postOrder(data) {
  return axios.post(apiEndpoint + "api/merch", data);
}
